import { api } from '@/modules/apiv2';

export default {
  actions: {
    async fetchCameraImage(_, { url }) {
      const response = await api.getResponse(url);
      const blob = await response.blob();
      const src = URL.createObjectURL(blob);

      return {
        src: src,
        url: response.url,
      };
    },

    async fetchNewestImageUrl({ getters }, { deviceId, camera, ownerId }) {
      const endpoint = getters.liveImagesEndpoint(ownerId);
      const liveImagesUrl = `${endpoint}/${deviceId}/images?camera=${camera}`;
      const imageList = await api.get(liveImagesUrl);
      if (imageList.length < 1) {
        console.warn(`got no images for camera ${camera}`);
        return null;
      }
      return imageList[0];
    },

    async fetchCameraImages({ getters }, { cameraIndex, startTime, endTime, ownerId, deviceId }) {
      const endpoint = getters.liveImagesEndpoint(ownerId);
      const imageUrl = `${endpoint}/${deviceId}/images?camera=${
        cameraIndex + 1
      }&startTime=${startTime}&endTime=${endTime}`;
      try {
        const response = await api.get(imageUrl);
        return response;
      } catch (error) {
        console.error(error);
        return [];
      }
    },
  },
};
